// DO NOT EDIT THIS FILE, EDIT THE WEBPACK COMMON CONFIG INSTEAD, WHICH WILL MODIFY THIS FILE
 /* tslint:disable */
let _VERSION = '0.0.1-SNAPSHOT'; // This value will be overwritten by webpack
let _DEBUG_INFO_ENABLED = true; // This value will be overwritten by webpack
_VERSION = '1.0.0-BETA';
_DEBUG_INFO_ENABLED = false;
/* tslint:enable */
export const VERSION = _VERSION;
export const DEBUG_INFO_ENABLED = _DEBUG_INFO_ENABLED;



// WEBPACK FOOTER //
// ./node_modules/string-replace-webpack-plugin/loader.js?id=t0hem4oqpwj!./src/main/webapp/app/main.constants.ts